export const COOKIE_EXPIRY_DAYS = 1;
